import Table, { TableBody, TableHeader } from '@ingka/table';
import Text from '@ingka/text';
import { useFormatWithLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import { useTranslation } from 'react-i18next';
import styles from './DrawDatesTable.module.scss';

type DrawDatesTableProps = {
  data: Array<{ startDate: string; endDate: string; drawDate: string }>;
};

export const DrawDatesTable: React.FC<DrawDatesTableProps> = ({ data }) => {
  const { t } = useTranslation();
  const { dateWithLocale } = useFormatWithLocale();

  return (
    <Table fullWidth className={styles['table']}>
      <TableHeader sticky>
        <tr>
          <th>
            <Text>{t('general-start-date')}</Text>
          </th>
          <th>
            <Text>{t('general-end-date')}</Text>
          </th>
          <th>
            <Text>{t('completed-draws-table-draw-date')}</Text>
          </th>
        </tr>
      </TableHeader>
      <TableBody striped>
        {data.map(({ startDate, endDate, drawDate }) => (
          <tr key={startDate}>
            <td>{dateWithLocale(startDate)}</td>
            <td>{dateWithLocale(endDate)}</td>
            <td>{dateWithLocale(drawDate)}</td>
          </tr>
        ))}
      </TableBody>
    </Table>
  );
};
